import { IonToolbar, IonButtons, IonBackButton, isPlatform, IonTitle } from "@ionic/react";

export const Toolbar = () => {
  return (
    <IonToolbar>
      <IonButtons slot="start">
        <IonBackButton
          text={isPlatform("ios") ? "Plantillas de archivo" : ""}
          defaultHref="/app/tic/plantillas-file"
          color="light"
        />
      </IonButtons>
      <IonTitle>Nueva plantilla de archivo</IonTitle>
    </IonToolbar>
  );
};
